import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { InvitesState } from './invites.state';
import { InvitesStore } from './invites.store';

@Injectable({ providedIn: 'root' })
export class InvitesQuery extends QueryEntity<InvitesState> {
  constructor(protected readonly store: InvitesStore) {
    super(store);
  }
}
